import React, { Component } from 'react';
import SwiperSlider, { SwiperSlide } from "./swiper";

class EquipmentRental extends Component {
    render() {
        const params = {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: true,
            breakpoints: {
                1200: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 2
                },
                576: {
                    slidesPerView: 1
                }
            }
        };

        let data = [
            {
                img: 'cat-d8-dozer.jpg',
                title: 'CAT Dozer D8',
                availability: '3 Available for Rental',
                description: 'Heavy-duty dozer perfect for large-scale earthmoving and grading operations. Powerful and reliable for demanding construction projects.',
                link: 'contact-us'
            },
            {
                img: 'cat-d9-dozer.jpg',
                title: 'CAT Dozer D9',
                availability: 'Available for Rental',
                description: 'Our most powerful dozer for extreme earthmoving tasks. Ideal for mining, quarrying, and large infrastructure projects.',
                link: 'contact-us'
            },
            {
                img: 'cat-d6-dozer.jpg',
                title: 'CAT Dozer D6',
                availability: 'Available for Rental',
                description: 'Versatile mid-size dozer offering excellent maneuverability and productivity for medium to large construction sites.',
                link: 'contact-us'
            },
            {
                img: 'cat-336l-excavator.jpg',
                title: 'CAT Excavator 336L',
                availability: '3 Available for Rental',
                description: 'High-performance hydraulic excavator designed for heavy digging, loading, and material handling applications.',
                link: 'contact-us'
            }
        ];

        let DataList = data.map((val, i) => {
            return (
                <SwiperSlide key={i}>
                    <div className="equipment-rental__single-item">
                        <div className="equipment-rental__image">
                            <a href={`${process.env.PUBLIC_URL}/${val.link}`}>
                                <img src={`assets/img/equipment/${val.img}`} className="img-fluid" alt={val.title} />
                            </a>
                        </div>
                        <div className="equipment-rental__content">

                            <h3 className="equipment-title">
                                <a href={`${process.env.PUBLIC_URL}/${val.link}`}>{val.title}</a>
                            </h3>
                            <p className="equipment-description">{val.description}</p>
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfQpwd9uw5gax003m5HZeaYc9PfBP_tzN3AVhJCxHB3QZkOnQ/viewform" target="_blank" rel="noopener noreferrer" className="rent-now-link">RENT NOW</a>
                        </div>
                    </div>
                </SwiperSlide>
            )
        });

        return (
            <div>
                {/*====================  equipment rental area ====================*/}
                <div className={`equipment-rental-area section-space--inner--120 ${this.props.background}`} data-aos="fade-up">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* section title */}
                                <div className="section-title-area text-center">
                                    <h2 className="section-title section-space--bottom--50">Equipment Available for Rental</h2>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="equipment-rental-wrapper">
                                    <SwiperSlider options={params}>
                                        {DataList}
                                    </SwiperSlider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of equipment rental area  ====================*/}
            </div>
        )
    }
}

export default EquipmentRental;
